<div class="layout">
  <main class="map-shell">
    <div id="map"></div>

    <section class="info-box length-box" *ngIf="selectedEdges.length">
      <div><strong>Länge:</strong> {{ totalSelectedLengthMeters | number:'1.2-2' }} m</div>
      <div class="series">
        <strong>Kanten:</strong>
        <span *ngFor="let edge of selectedEdges; let last = last">
          ({{ edge.fromPointId }}, {{ edge.toPointId }})<span *ngIf="!last">, </span>
        </span>
      </div>
    </section>

    <section class="info-box area-box" *ngIf="selectedParcels.length">
      <div><strong>Fläche:</strong> {{ totalSelectedAreaSquareMeters | number:'1.2-2' }} m2</div>
      <div class="series">
        <strong>Grundstücke:</strong>
        <span *ngFor="let parcel of selectedParcels; let last = last">
          {{ parcel.parcelName }}<span *ngIf="!last">, </span>
        </span>
      </div>
    </section>
  </main>

  <aside class="pdf-panel" *ngIf="selectedPdfUrl">
    <header>
      <h2>{{ selectedPdfTitle }}</h2>
      <button type="button" (click)="closePdf()">×</button>
    </header>
    <iframe [src]="selectedPdfUrl"></iframe>
  </aside>
</div>
